import { render, staticRenderFns } from "./ManufacturingStep3.vue?vue&type=template&id=56705103&"
import script from "./ManufacturingStep3.vue?vue&type=script&lang=js&"
export * from "./ManufacturingStep3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports